import { DialogTitle, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

import { styleConfigs } from '../resources/styleConfigs';
import DialogWrapper from '../wrappers/DialogWrapper';

export const ChangePasswordDialogStyle = styled(DialogWrapper)(() => ({
  '& .MuiDialogContent-root': {
    padding: styleConfigs.marginPadding.custom24,
  },
}));

export const ChangePasswordDialogTitleStyle = styled(DialogTitle)(({ theme }) => ({
  minWidth: styleConfigs.dimensions.width435,
  maxWidth: styleConfigs.dimensions.width435,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontWeight: styleConfigs.fonts.bold,
  fontSize: `${styleConfigs.fonts.fontSize20} !important`,
  color: theme.palette.text.ebonyClay,
  padding: `${styleConfigs.marginPadding.custom38}px ${styleConfigs.marginPadding.custom36}px 
  ${styleConfigs.marginPadding.custom30}px ${styleConfigs.marginPadding.custom24}px`,
  [theme.breakpoints.down('sm')]: {
    minWidth: styleConfigs.dimensions.width368,
    fontSize: `${styleConfigs.fonts.fontSize18} !important`,
    padding: `${styleConfigs.marginPadding.custom18}px ${styleConfigs.marginPadding.custom24}px`,
  },
}));

export const CloseIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.icons.mistBlue,
  padding: styleConfigs.marginPadding.empty,
}));
